import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState } from '../../../../../store/rootReducer';
import LinkButton from '../../../../common/LinkButton';
import InterestedModal from '../../modal/interested';
import { Deal } from '../../redux/types';
import DealFAQ from '../FAQ';
import DealFreeText from '../FreeText';
import DealTeam from '../Team';

type Props = {
    deal: Deal | undefined;
};

const DealOverview: React.FC<Props> = ({ deal }) => {
    let uuid = useParams().uuid;
    const navigate = useNavigate();
    const team = useSelector((state: RootState) => state.deal.deal?.team);
    const faq = useSelector((state: RootState) => state.deal.deal?.faq);
    const freeText = useSelector((state: RootState) => state.deal.deal?.freeText);
    const termSheetData = useSelector((state: RootState) => state.deal.termSheetData);

    const toTermSheet = () => {
        if (uuid) {
            navigate(`/deal/${uuid}/term-sheet`);
        }
    };
    return (
        <>
            {deal && (
                <>
                    {deal.info.details &&
                        deal.info.details.map((d, index) => (
                            <div key={`deal_details_${index}_${d.key}`} className="pt-6">
                                <p className="text-[#142C53] text-2xl font-[WorkSans-Semibold] uppercase font-bold  my-1.5 common_read_title">
                                    {d.key}
                                </p>
                                <ul className="list-disc pl-4 mb-1.5">
                                    {d.value &&
                                        d.value.map((v, index1) => (
                                            <li key={`value_${index}_${index1}_${d.key}`} className="py-1 ">
                                                <p className="w-full text-sm text-[#20222B] font-[Lato] text-justify">
                                                    {v}
                                                </p>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        ))}
                </>
            )}
            {freeText && freeText.length > 0 && <DealFreeText freeText={freeText} />}
            {deal && (
                <div className="flex gap-2 items-center w-full mt-6 flex-col md:flex-row">
                    <InterestedModal deal={deal} />
                    {termSheetData && <LinkButton title="Term Sheet" isArrow={true} onClick={toTermSheet} />}
                </div>
            )}
            {team && team.length > 0 && <DealTeam team={team} />}
            {faq && faq.length > 0 && <DealFAQ faq={faq} deal={deal} />}
        </>
    );
};

export default DealOverview;
